import {h} from "vue";
import CertificatePicker from "../components/popups/CertificatePicker.vue";


export function useCertificatePicker(appContext?: any) {
  const dialog = appContext?.config?.globalProperties?.$dialog

  async function pickCertificate(): Promise<any | null> {
    return new Promise(resolve => {
      dialog.open(h(CertificatePicker), {
        props: {
          header: "Select certificate",
          modal: true,
          style: {width: "600px"}
        },
        onClose: (data: any) => {
          resolve(data?.data ?? null)
        }
      });
    });
  }

  function fileToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () =>
        resolve((reader.result as string).split(",")[1]);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  async function pickAndSign(file: File) {
    const cert = await pickCertificate();
    if (!cert) return null;

    const fileBase64 = await fileToBase64(file);

    return {
      fileBase64,
      thumbprint: cert.thumbprint
    };
  }

  return {pickCertificate, pickAndSign};
}
